import React from 'react';
import { Box, Text, Tooltip } from '@chakra-ui/react';

const NoAnswerCell = ({ ...props }) => (
  <Box {...props}>
    <Tooltip label="No answers have been provided yet">
      <Text>–</Text>
    </Tooltip>
  </Box>
);

export default NoAnswerCell;
